import { Box, Flex, Separator, Theme } from '@radix-ui/themes';
import { Tabs } from 'radix-ui';
import { PropsWithChildren } from 'react';

import { DataCardLayout } from './DataCardLayout';
import styles from './Metrics.module.css';

export interface DataTabCardProps<TTabState extends string>
    extends PropsWithChildren {
    value: TTabState;
    title: string;
    content: string;
    subTitle?: string;
}

export const DataTabCard = <T extends string>({
    value,
    ...dataCard
}: DataTabCardProps<T>) => (
    <Tabs.Trigger value={value} className={styles.tabsTrigger}>
        <Flex gap={'4'}>
            <Box>
                <Theme asChild>
                    <Separator
                        className={styles.tabIndicator}
                        orientation={'vertical'}
                        size={'4'}
                    />
                </Theme>
            </Box>

            <DataCardLayout {...dataCard} />
        </Flex>

        <Box className={styles.tabPointer} />
    </Tabs.Trigger>
);
